import React, { useEffect } from "react";
import ReusableTable from "components/Tables/ReusableTable";
import Skeleton from "react-loading-skeleton";
import 'react-loading-skeleton/dist/skeleton.css';
import { Flex, Box, Text } from "@chakra-ui/react";
import { MessageSquare, EllipsisVertical } from "lucide-react";
import ThreeDotMenu from "components/Menus/ThreeDotMenu";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { fetchReviewsAction } from "state/actions/reviewActions";

const RatingManagement = () => {
  const history = useHistory();
  const dispatch = useDispatch();

  const { reviews, loading, error } = useSelector((state) => state.reviews);

  useEffect(() => {
    dispatch(fetchReviewsAction()); // Add filterField, filterValue if needed
  }, [dispatch]);

  const generateMenuItems = (row) => [
    {
      icon: <MessageSquare size={16} />,
      text: "Chat with User",
      onClick: () => history.push("/admin/messages"),
    },
  ];

  const getDisplayName = (user) => {
    if (!user) return "Unknown";
    if (user.first_name || user.last_name) {
      return `${user.first_name || ''} ${user.last_name || ''}`.trim();
    }
    if (user.username) {
      return user.username;
    }
    return "No name available";
  };

  const columnsData = [
    {
      Header: "Reviewer Name",
      accessor: "reviewer_name",
      Cell: ({ row }) => {
        const name = row.original.reviewer_name || "Unknown";
        const phone = row.original.reviewer_phone || "N/A";
        const village = row.original.reviewer_village || "N/A";
        return `${name} (${phone}, ${village})`;
      },
    },
    {
      Header: "Driver Reviewed",
      accessor: "driver_name",
      Cell: ({ row }) => {
        const name = row.original.driver_name || "Unknown";
        const phone = row.original.driver_phone || "N/A";
        const village = row.original.driver_village || "N/A";
        return `${name} (${phone}, ${village})`;
      },
    },
    {
      Header: "Rating Type",
      accessor: "rating_type",
    },
    {
      Header: "Rating",
      accessor: "rating",
      Cell: ({ value }) => {
        const stars = Array.from({ length: 5 }, (_, index) => (
          <span key={index} style={{ color: index < value ? "gold" : "lightgray" }}>
            ★
          </span>
        ));
        return <Flex alignItems="center">{stars}</Flex>;
      },
    },
    {
      Header: "Review",
      accessor: "review",
    },
    {
      Header: "Review Date",
      accessor: "review_date",
      Cell: ({ value }) => new Date(value).toLocaleDateString(),
    },
    {
      Header: "Actions",
      accessor: "moreOptions",
      Cell: ({ row }) => (
        <ThreeDotMenu
          icon={<EllipsisVertical size={20} color="grey" />}
          items={generateMenuItems(row.original)}
        />
      ),
    },
  ];
  const formattedReviews = reviews.map(review => ({
    review_id: review.review.review_id,
    reviewer_name: getDisplayName(review.user_info),
    reviewer_phone: review.user_info?.phone_number || "N/A",
    reviewer_village: review.user_info?.village || "N/A",
    driver_name: getDisplayName(review.driver_user_info),
    driver_phone: review.driver_user_info?.phone_number || "N/A",
    driver_village: review.driver_user_info?.village || "N/A",
    rating_type: review.review.rating_type,
    rating: review.review.rating,
    review: review.review.review,
    review_date: review.review.review_date,
  }));
  
  return (
    <Flex flexDirection="column" pt={{ base: "120px", md: "75px" }}>
      <Box p={6}>
        <Flex justifyContent="space-between" alignItems="center">
          {loading ? (
            <Box width="120px">
              <Skeleton height="20px" />
            </Box>
          ) : (
            <Text fontSize="md" fontWeight="bold">
              All Reviews: {reviews.length}
            </Text>
          )}
        </Flex>
      </Box>
      <ReusableTable columnsData={columnsData} tableData={formattedReviews} isLoading={loading} />
    </Flex>
  );
};

export default RatingManagement;
